import { RootState } from '@box/redux/types';

export const status = (state: RootState) => state.loyalty.user.status;
export const nextStatus = (state: RootState) => state.loyalty.user.nextStatus;
export const points = (state: RootState) => state.loyalty.user.points;
export const currentRating = (state: RootState) =>
  state.loyalty.user.currentRating;
export const nextRating = (state: RootState) => state.loyalty.user.nextRating;
